import { gql } from "graphql-tag";

export const GET_MILESTONES_FOR_PROJECTS = gql`
  query GetMilestonesForProjects($projectIds: [ID!]!) {
    milestonesForProjects(projectIds: $projectIds) {
      id
      name
      rank
      important
      color
      description
      phase {
        id
        name
      }
    }
  }
`;
